"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointCardSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PickupPointCardSkeleton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.PickupPointCardSkeleton),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.RadioSkeleton, {
      animation: "pulse",
      variant: "circular",
      height: 20,
      width: 20
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
        animation: "pulse",
        variant: "rectangular",
        height: 26,
        width: 53
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
        animation: "pulse",
        variant: "rectangular",
        height: 20,
        width: 169
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextSkeleton, {
        animation: "pulse",
        variant: "rectangular",
        height: 20,
        width: 169
      })]
    })]
  });
};
exports.PickupPointCardSkeleton = PickupPointCardSkeleton;